import React, { useState, useEffect } from 'react';
import { SectionElement } from '@fulcrumapp/fulcrum-core';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Collapse from '../../shared/collapse';
import { useApp } from '../../hooks/use-app';
import FormSectionTitle from './deprecated-form-section-title';

const Spacer = styled(Box)({
  height: 7,
  backgroundColor: '#efefef',
});

interface Props {
  element: SectionElement;
  children?: Element | React.ReactNode;
  visible: boolean;
  dataTestID: string;
  onDrillDownSectionClick: (el: SectionElement) => void;
}
/**
 * @deprecated this field is deprecated. use the custom-accordion
 */
const FormSection: React.FC<Props> = ({
  element,
  children,
  visible,
  dataTestID,
  onDrillDownSectionClick,
}: Props) => {
  const app = useApp();
  const {
    description, isDrillDown, isInline, key, label,
  } = element;
  const isExpanded = app.preferences.isSectionExpanded(key);
  const [expandedFlag, setExpandedFlag] = useState<boolean>(isExpanded);

  const handleHeaderClick = (): void => {
    if (isDrillDown) {
      onDrillDownSectionClick(element);
    } else {
      const toggleExpanded = !expandedFlag;

      setExpandedFlag(toggleExpanded);
      app.preferences.setSectionExpanded(key, toggleExpanded);
    }
  };

  useEffect(() => {
    setExpandedFlag(isExpanded);
  }, [key]);

  return (
    // @ts-ignore
    <Collapse open={visible} style={{ width: '100%' }} key={key} dataTestID={dataTestID}>
      <FormSectionTitle
        onClick={handleHeaderClick}
        expanded={isInline ? expandedFlag : true}
        isDrillDown={isDrillDown}
        label={label}
        description={description}
      />
      { isInline ? <Collapse open={expandedFlag}>{children}</Collapse> : null }
      <Spacer sx={{ borderBottom: expandedFlag || isDrillDown ? '1px solid #d9d9d9' : 'none' }} />
    </Collapse>
  );
};

export default FormSection;
